import { render } from "./AssignUnAssignAC.vue?vue&type=template&id=6328ef33"
import script from "./AssignUnAssignAC.vue?vue&type=script&lang=js"
export * from "./AssignUnAssignAC.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__